import { render, staticRenderFns } from "./top-icon.vue?vue&type=template&id=63e2218d&scoped=true"
import script from "./top-icon.vue?vue&type=script&lang=js"
export * from "./top-icon.vue?vue&type=script&lang=js"
import style0 from "./top-icon.vue?vue&type=style&index=0&id=63e2218d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2218d",
  null
  
)

export default component.exports